import Navigation from './Navigation'

export default Navigation;
